import { useTranslation } from 'react-i18next';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[500px] md:min-h-[560px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Urban%20street%20style%20fashion%20photography%20with%20sneakers%20denim%20jacket%20vintage%20backpack%20and%20accessories%20styled%20on%20concrete%20steps%20with%20green%20ivy%20wall%20background%20soft%20afternoon%20sunlight%20creating%20natural%20lens%20flare%20editorial%20fashion%20campaign%20aesthetic%20with%20earthy%20tones%20modern%20European%20streetwear%20vibe%20dynamic%20yet%20clean%20composition&width=1800&height=900&seq=kakobuy-cta-v2-2026&orientation=landscape"
          alt="Kakobuy Sheet - najlepsze produkty"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/30 to-foreground-950/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight mb-4">
            {t('cta.title')}
          </h2>
          <p className="text-base md:text-lg text-background-100/90 max-w-xl mx-auto mb-10">
            {t('cta.subtitle')}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group px-10 py-4 rounded-full bg-foreground-950 text-background-50 font-semibold text-sm hover:bg-foreground-900 transition-all cursor-pointer whitespace-nowrap flex items-center gap-3"
            >
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
                <i className="ri-shopping-bag-line text-background-50 text-sm w-4 h-4 flex items-center justify-center"></i>
              </div>
              <span>{t('cta.button')}</span>
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-10 py-4 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 font-semibold text-sm hover:bg-background-50/25 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <span>Kup teraz</span>
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}